/* eslint-disable
    import/no-unresolved,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
require('./documentCard.scss');

const deps = [
  require('data/collection/document').name,
  require('data/collection/ledger').name,
  require('ui/web/table').name,
  require('ui/web/form').name,
  require('ui/web/paginate').name,
  require('ui/web/statusSelector').name,
  require('ui/web/simpleCheckbox').name,
  require('ui/web/documentCard/dmsTable').name,
];

module.exports = angular
  .module('bench.ui.documentCard', deps)

  .directive('blDocumentCard', () => ({
    restrict: 'E',
    scope: {
      clientId: '=',
      addOnId: '=',
      documentType: '@',
      date: '=',
      page: '=',
      ledgerId: '=',
      fileName: '=',
      hasFileNameSearch: '=',
      archived: '=',
      refetch: '=',
    },
    bindToController: true,
    template: require('./documentCard.html'),
    controller: require('./documentCardCtrl.js'),
    controllerAs: 'vm',
  }));
